import React from 'react'
import styled from 'styled-components'
import Toast from './Toast'
import type { ToastProps, ToastPlacement } from './Toast'

interface ToastContainerProps {
  toasts: ToastProps[]
  removeToast: (key: string) => void
}

export default function ToastContainer({ toasts, removeToast }: ToastContainerProps) {
  // istanbul ignore next
  const placements: ToastPlacement[] = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'top', 'bottom']

  const groupedToasts = React.useMemo(() => {
    return placements.reduce((acc, placement) => {
      acc[placement] = toasts.filter((toast) => toast.placement === placement)
      return acc
    }, {} as Record<ToastPlacement, ToastProps[]>)
  }, [toasts])
  
  return (
    <>
      {placements.map(
        (placement) =>
          groupedToasts[placement].length > 0 && (
            <Container key={placement} placement={placement} data-testid={`toast-container-${placement}`}>
              {groupedToasts[placement].map((toast) => (
                <React.Fragment key={toast.toastKey}>
                  <Toast {...toast} removeToast={removeToast} />
                </React.Fragment>
              ))}
            </Container>
          )
      )}
    </>
  )
}

interface ContainerProps {
  placement: ToastPlacement
}

const Container = styled.div<ContainerProps>`
  pointer-events: none;
  z-index: 100000;
  position: fixed;
  ${(props) =>
    props.placement.includes('top')
      ? 'top: 0;'
      : props.placement.includes('bottom')
      ? 'bottom: 0;'
      : ''}
  ${(props) =>
    props.placement === 'top' || props.placement === 'bottom'
      ? `
          left: 50%;
          transform: translateX(-50%);
        `
      : props.placement.includes('Left')
      ? 'left: 0;'
      : 'right: 0;'}
  padding: 16px;
  display: flex;
  flex-direction: column;
  ${(props) => (props.placement === 'top' || props.placement === 'bottom' ? 'align-items: center;' : '')}
`;